/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M413 90c-178 0-323 145-323 323s145 323 323 323c67 0 129-20 181-55l227 227c12 12 31 12 43 0l43-43c12-12 12-31 0-43L680 595c35-52 56-115 56-182 0-178-145-323-323-323zm0 116c114 0 207 93 207 207s-93 207-207 207-207-93-207-207 93-207 207-207z"/>'
  }
})
